<template>
  <BaseModal
    :value="true"
    id="new-payment-modal"
    @input="$emit('close')"
    :clickOutsideClose="false"
  >
    <h1 class="mb-8">New Payment</h1>
    <div class="bar">
      <button
        class="tablinks"
        :class="{ active: type === 'quickpay' }"
        @click="type = 'quickpay'"
      >
        Awaiting Payment Orders
      </button>
      <button
        class="tablinks"
        :class="{ active: type === 'order' }"
        @click="type = 'order'"
      >
        Customer Orders
      </button>
      <button
        class="tablinks"
        :class="{ active: type === 'basic' }"
        @click="type = 'basic'"
      >
        Basic
      </button>
    </div>
    <div v-if="type == 'order'">
      <CustomerOrdersPosPayment
        @newPaymentProcessed="$emit('newPaymentProcessed', $event)"
        @openReceipt="$emit('singlePayment', $event)"
      ></CustomerOrdersPosPayment>
    </div>
    <div v-if="type == 'basic'">
      <BasicPosPayment
        @newPaymentProcessed="$emit('singlePayment', $event)"
      ></BasicPosPayment>
    </div>
    <div v-if="type == 'quickpay'">
      <QuickOrderPayment
        @newPaymentProcessed="$emit('newPaymentProcessed', $event)"
        @openReceipt="$emit('singlePayment', $event)"
      ></QuickOrderPayment>
    </div>
  </BaseModal>
</template>
<script>
import BasicPosPayment from "@/components/payments/BasicPosPayment.vue";
import CustomerOrdersPosPayment from "@/components/payments/CustomerOrdersPosPayment.vue";
import QuickOrderPayment from "@/components/payments/QuickOrderPayment.vue";
export default {
  name: "NewPaymentModal",
  components: {
    BasicPosPayment,
    CustomerOrdersPosPayment,
    QuickOrderPayment
  },
  data() {
    return {
      type: "order"
    };
  },
  methods: {
    singlePayment(transactionId) {
      this.$emit("singlePayment", transactionId);
    }
  }
};
</script>
<style lang="postcss">
#new-payment-modal .modal-content {
  width: 90%;
  max-width: 1000px;
}
</style>
